module.exports = require('react/lib/LinkedStateMixin');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-linked-state-mixin/index.js
 ** module id = 534
 ** module chunks = 0
 **/